import { BannerInfo } from '~/api/repository'
import { contentType, eventType } from '~/types/content.type'
import { capitalizeFirstLetter } from '~/utils/string'

export class BannerModel {
  private readonly _category: string
  private readonly _title: string
  private readonly _timestamp: string
  private readonly _contentId: string

  constructor (res: BannerInfo) {
    this._category = res.TAG
    this._title = res.TI
    this._timestamp = res.PDT
    this._contentId = res.CID
  }

  get category (): string {
    if (this._category in eventType) {
      return capitalizeFirstLetter(contentType.EVENT)
    }
    return capitalizeFirstLetter(this._category)
  }

  get title (): string {
    return this._title
  }

  get timestamp (): string {
    return this._timestamp
  }

  get contentId (): string {
    return this._contentId
  }

  get eventType () {
    if (this._category in eventType) {
      return this._category
    }
    return null
  }
}